const listeners = new Set();
let activeRequests = 0;

function notify() {
  listeners.forEach((listener) => listener(activeRequests > 0));
}

export function subscribeLoading(listener) {
  listeners.add(listener);
  listener(activeRequests > 0);
  return () => listeners.delete(listener);
}

export function startLoading() {
  activeRequests += 1;
  notify();
}

export function stopLoading() {
  activeRequests = Math.max(0, activeRequests - 1);
  notify();
}
